<template>
  <div class="blog-Management-modular">
    <div class="blog-body-modular">
      <el-row :gutter="90">
        <el-col :span="16" :xs="24">
          <div class="search-result-input">
            <el-input
              :placeholder="$t('translateText.placeholdercontentsText')"
              v-model="searchKey"
              class="input-with-select"
            >
              <el-button slot="append" @click="getBlogList()">搜索</el-button>
            </el-input>
          </div>
          <div class="blog-body-left-modular">
            <div class="news-modualr">
              <div v-if="newList.length == 0" class="my-evaluate-bodu-none">
                <img
                  class="none-icon"
                  src="../assets/public/none-icon.png"
                  alt=""
                />
                <p class="none-title">
                  {{ $t("translateText.NoDataText") + "~" }}
                </p>
              </div>
              <div
                class="news-list-item-modular"
                v-else
                v-for="(item, index) in newList"
                :key="index"
              >
                <el-row :gutter="20">
                  <el-col :span="8" :xs="24">
                    <div class="news-item-left">
                      <img
                        class="news-item-img"
                        @click="toBolgDeatil(item.id)"
                        :src="item.cover"
                        alt=""
                      />
                    </div>
                  </el-col>
                  <el-col :span="16" :xs="24">
                    <div class="news-item-right">
                      <div
                        class="news-item-title"
                        @click="toBolgDeatil(item.id)"
                        v-html="item.title"
                      >
                      </div>
                      <div class="news-item-content">
                        <div v-html="item.detail"></div>
                        <!-- <div>
                              {{
                                currLanguage == 3
                                  ? item.eng_description
                                  : item.description
                              }}
                            </div> -->
                      </div>
                      <div class="news-item-publisher-date-modular">
                        <div class="news-item-publisher-date">
                          <div class="news-item-publisher">
                            <span class="news-item-tags">文</span>/
                            <div v-html="item.writer" class="news-item-writer"></div>
                          </div>
                          <div class="news-item-date">
                            {{ item.create_time }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="pagination-footer-modualr" v-if="pageCount > 1">
              <el-pagination
                :pager-count="11"
                background
                layout="prev, pager, next"
                :total="pageCount"
              >
              </el-pagination>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24">
          <div class="blog-body-right-modular">
            <div class="division-line" style="margin: 0"></div>
            <div class="hot-blog-modular">
              <div class="hot-blog-title">
                {{ $t("translateText.blogmanagementText") }}
              </div>
              <div class="hot-blog-division-line"></div>
              <div v-if="hotBlogList.length == 0" class="my-evaluate-bodu-none">
                <img
                  class="none-icon"
                  src="../assets/public/none-icon.png"
                  alt=""
                />
                <p class="none-title">
                  {{ $t("translateText.NoDataText") + "~" }}
                </p>
              </div>
              <div class="hot-blog-list-modualr" v-else>
                <div
                  class="hot-blog-item"
                  v-for="(item, index) in hotBlogList"
                  :key="index"
                >
                  <div class="hot-blog-item-top" v-if="index < 2">
                    <img
                      class="hot-blog-item-top-img"
                      :src="item.cover"
                      alt=""
                    />
                    <div class="hot-blog-item-top-title">{{ item.title }}</div>
                    <img
                      class="top-icon"
                      v-if="index == 0"
                      src="../assets/blog/top1-icon.png"
                      alt=""
                    />
                    <img
                      class="top-icon"
                      v-else
                      src="../assets/blog/top2-icon.png"
                      alt=""
                    />
                  </div>
                  <div class="hot-blog-item-other" v-else>
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <div class="hot-blog-item-other-img">
                          <img
                            class="item-other-img"
                            :src="item.cover"
                            alt=""
                          />
                          <img
                            class="top-icon"
                            v-if="index == 2"
                            src="../assets/blog/top3-icon.png"
                            alt=""
                          />
                          <img
                            class="top-icon"
                            v-if="index == 3"
                            src="../assets/blog/top4-icon.png"
                            alt=""
                          />
                          <img
                            class="top-icon"
                            v-if="index == 4"
                            src="../assets/blog/top5-icon.png"
                            alt=""
                          />
                        </div>
                      </el-col>
                      <el-col :span="16">
                        <div class="hot-blog-item-other-info">
                          <div class="hot-blog-item-other-title">
                            {{ item.title }}
                          </div>
                          <div class="hot-blog-item-other-date">
                            {{ item.date }}
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>
            <div class="division-line"></div>
            <div class="newsest-blog-modualr">
              <div class="newsest-blog-title">
                {{ $t("translateText.latestblogsText") }}
              </div>
              <div class="newsest-blog-division-line"></div>
              <div
                v-if="newestBlogList.length == 0"
                class="my-evaluate-bodu-none"
              >
                <img
                  class="none-icon"
                  src="../assets/public/none-icon.png"
                  alt=""
                />
                <p class="none-title">
                  {{ $t("translateText.NoDataText") + "~" }}
                </p>
              </div>
              <div
                class="newsest-blog-item"
                v-else
                v-for="(item, index) in newestBlogList"
                :key="index"
              >
                <img
                  class="right-tag-icon"
                  src="../assets/blog/red-right-tag-icon.png"
                  alt=""
                />
                <span class="newsest-blog-conent">{{ item.title }}</span>
                <div class="newsest-blog-date">{{ item.create_time }}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabActiveLable: "锦格之家",
      activeBlogTypeId: "",
      searchKey: "", //搜索关键词
      blogTypeData: [], //博客类型列表
      page: 1,
      pageSize: 10,
      pageCount: 0, //总页数
      bannerImg: [], //轮播
      newList: [], //博客
      hotBlogList: [], //热门博客
      newestBlogList: [], //最新博客
      bannerHeight: "300px",
    };
  },
  methods: {
    join(str) {
      let key = this.searchKey
      var reg = new RegExp(`(${key})`, "gi");
      var replace = '<span style="color:#5F69AE;">$1</span>';
      return  str.replace(reg, replace);
    },
    /**
     * 判断是手机还是PC
     */
    judgePcOrPhone() {
      let that = this;
      let type = localStorage.getItem("equipmentType");
      if (type == 1) {
        that.bannerHeight = "220px";
      } else {
        that.bannerHeight = "300px";
      }
    },

    /**
     * 获取博客列表
     */
    getBlogList() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pageSize,
        title: that.searchKey,
      };

      this.$http.blogList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.newList = res.blogList;
            if(that.searchKey) {
              that.newList.forEach(item=>{
                item.title = that.join(item.title)
                item.detail = that.join(item.detail)
              })
            }
            that.pageCount = parseInt(res.total);
          } else {
            that.newList = res.blogList;
            that.pageCount = 0;
            this.$message.error(res.msg);
          }
        },
        (res) => {
          that.newList = res.blogList;
          that.pageCount = 0;
          this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取热门 - 最新博客
     */
    getHotAndHotBlogList() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pageSize,
        type_id: that.activeBlogTypeId,
      };

      this.$http.blogList(
        data,
        (res) => {
          if (res.ret == 1) {
            // 热门
            that.hotBlogList = res.hotList;
            // 最新
            that.newestBlogList = res.newList;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取轮播图片 bannerImg
     */
    getBannerImg() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pageSize,
        type_id: that.activeBlogTypeId,
      };
      this.$http.blogList(
        data,
        (res) => {
          if (res.ret == 1) {
            res.blogList.forEach((v, i) => {
              if (i < 3) {
                that.bannerImg.push({ img: v.cover });
              }
            });
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },

    /**
     * 跳转博客详情
     */
    toBolgDeatil(blogId) {
      this.$router.push({
        path: "/bolgDeatil",
        query: { name: this.tabActiveLable, uuid: blogId },
      });
    },
  },
  mounted() {
    let that = this;
    // 判断是手机还是PC
    that.judgePcOrPhone();
    that.searchKey = that.$route.query.searchKey;
    // that.activeBlogTypeId = that.$route.query.typeId;
    // 博客列表
    that.getBlogList();
    // 获取banner
    // that.getBannerImg();
    // 获取热门 - 最新博客
    that.getHotAndHotBlogList();
  },
};
</script>


// WEBPACK FOOTER //
// src/view/blogSearchManagement.vue